
// nessuna rotta di sviluppo dedicata a livegift
const dev = []

export {
  dev
}